import Dashboard, {
    DashboardAccess,
    DashboardAccessVisibility,
    DashboardPermittedAction,
    DashboardPermittedActions,
    UserGroupLevel,
} from 'domain/entity/dashboard';

type DashboardUserGroupJson = {
    id: string;
    name: string;
    level: UserGroupLevel;
};

export type DashboardAccessJson = {
    visibility: string;
    groups: DashboardUserGroupJson[];
};

export type DashboardJson = {
    id: string;
    name: string;
    pinned: boolean;
    access: DashboardAccessJson;
    owner: { me: boolean };
    ['permitted_actions']: string[];
    starred: boolean;
};

const asDashboardPermittedActions = (dashboardPermittedActionsJson: string[]): DashboardPermittedActions => ({
    delete: dashboardPermittedActionsJson.includes(DashboardPermittedAction.DELETE),
    edit: dashboardPermittedActionsJson.includes(DashboardPermittedAction.EDIT),
    link: dashboardPermittedActionsJson.includes(DashboardPermittedAction.LINK),
    share: dashboardPermittedActionsJson.includes(DashboardPermittedAction.SHARE),
    pin: dashboardPermittedActionsJson.includes(DashboardPermittedAction.PIN),
    duplicate: dashboardPermittedActionsJson.includes(DashboardPermittedAction.DUPLICATE),
});

const asDashboardAccess = (accessJson: DashboardAccessJson): DashboardAccess => ({
    visibility: accessJson.visibility as DashboardAccessVisibility,
    groups: accessJson.groups,
});

export const asDashboard = (dashboardJson: DashboardJson): Dashboard => {
    if (dashboardJson.id === undefined) {
        throw new ReferenceError('Undefined required Id');
    }
    return new Dashboard(
        dashboardJson.id,
        dashboardJson.name,
        dashboardJson.pinned,
        asDashboardAccess(dashboardJson.access),
        dashboardJson.owner,
        asDashboardPermittedActions(dashboardJson.permitted_actions),
        dashboardJson.starred
    );
};
